let MAP_KEY = "AIzaSyBueJkoLK9q9p-8mDKsX8Kv12L0EMiVevc"; //slt
let FTTH_AMOUNT = 10000.00
let LTE_AMOUNT = 3900.00
if(process.env.REACT_APP_ENV === 'DEVELOPMENT' ) {
    MAP_KEY = "AIzaSyAMXJrO2RJvxOSPjp4MBZg-F-IbogtSyLQ";  //"AIzaSyAMXJrO2RJvxOSPjp4MBZg-F-IbogtSyLQ"; //lakmobile
    FTTH_AMOUNT = 10.00
    LTE_AMOUNT = 10.00
}
export {MAP_KEY, FTTH_AMOUNT, LTE_AMOUNT}